/** Тексты окна: Ярлык на экран телефона. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.homeScreen.title": "Add the game to your home screen?",
  "win.homeScreen.text":
    "The icon opens the game in one tap. Telegram will briefly open its own page, then come back to the game.",
  "win.homeScreen.add": "Add",
  "win.homeScreen.decline": "Not now",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.homeScreen.title": "Добавить игру на экран?",
  "win.homeScreen.text":
    "Значок откроет игру в одно касание. Telegram ненадолго покажет свою страницу, потом вернись в игру.",
  "win.homeScreen.add": "Добавить",
  "win.homeScreen.decline": "Не сейчас",
};

const uk: Record<Key, string> = {
  "win.homeScreen.title": "Додати гру на екран?",
  "win.homeScreen.text":
    "Значок відкриє гру одним дотиком. Telegram ненадовго покаже свою сторінку, потім повернися в гру.",
  "win.homeScreen.add": "Додати",
  "win.homeScreen.decline": "Не зараз",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
